import { Component, input, output, computed, effect, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoSvgIconUI } from '../so-svg-icon/so-svg-icon.component';

export type SoToastType = 'success' | 'error' | 'info';
export type SoToastPosition = 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'bottom-center';

@Component({
  selector: 'so-toast-ui',
  standalone: true,
  imports: [CommonModule, SoSvgIconUI],
  templateUrl: './so-toast.component.html',
  styleUrl: './so-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoToastUI {
  message = input<string>('');
  type = input<SoToastType>('success');
  visible = input<boolean>(false);
  duration = input<number>(3000);
  position = input<SoToastPosition>('top-right');

  closed = output<void>();

  protected icon = computed(() => {
    const iconMap: Record<SoToastType, string> = {
      success: 'check_circle',
      error: 'error',
      info: 'info'
    };
    return iconMap[this.type()];
  });

  protected iconColor = computed(() => {
    const colorMap: Record<SoToastType, string> = {
      success: '--so-success',
      error: '--so-danger',
      info: '--so-info'
    };
    return colorMap[this.type()];
  });

  protected positionClass = computed(() => `so-toast--pos-${this.position()}`);

  constructor() {
    effect((onCleanup) => {
      if (this.visible()) {
        const timer = setTimeout(() => this.closed.emit(), this.duration());
        onCleanup(() => clearTimeout(timer));
      }
    });
  }

  dismiss(): void {
    this.closed.emit();
  }
}
